import { jsx as reactJsx, jsxs as reactJsxs } from "react/jsx-runtime";
import { wrap } from "../wrap";

export const jsx = wrap(reactJsx);
export const jsxs = wrap(reactJsxs);
